module.exports = __webpack_public_path__ + "img/刘俊怡副教授.3f3b6cfc.png";